import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

const instructions = [
  {
    title: "How Register and Book an Appointment",
    lines: [
      "1. Select whom you are booking for.",
      "2. Select a specific branch you want to go. you have an option to search or filter the branches",
    ],
    img: "/images/help-1.svg",
  },
  {
    title: "Select Service & Date",
    lines: [
      "3. Enter your phone number and verify using the OTP you receive on your phone number."
    ],
    img: "/images/help-2.svg",
  },
  {
    title: "Confirm & Pay",
    lines: [
      "4. Once verified, choose the service you require.",
    ],
    img: "/images/help-3.svg",
  },
   {
    title: "Confirm & Pay",
    lines: [
      "5. Select the date and time for your appointment.",
    ],
    img: "/images/help-4.svg",
  },
   {
    title: "Confirm & Pay",
    lines: [
      "6. Confirm you appointment and and pay using Telebirr using the popup appears on your phone"
    ],
    img: "/images/help-5.svg",
  },
  {
    title: "Confirm & Pay",
    lines: [
      "7. Enter your Telebirr PIN and verify to complete the booking."
    ],
    img: "/images/help-6.svg",
  },
]

export default function HelpPage() {
  const [index, setIndex] = useState(0)
  const { t } = useTranslation()

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === "ArrowLeft") prev()
      if (e.key === "ArrowRight") next()
    }
    window.addEventListener("keydown", onKey)
    return () => window.removeEventListener("keydown", onKey)
  }, [])

  const prev = () => setIndex((i) => (i - 1 + instructions.length) % instructions.length)
  const next = () => setIndex((i) => (i + 1) % instructions.length)

  const step = instructions[index]

  return (
    <div className=" flex items-center justify-center p-6">
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-lg p-8 relative">
        <h1 className="text-center text-lg font-semibold text-gray-900">
          {t("How Register and Book an Appointment")}
        </h1>

        <div className="mt-4 text-sm text-gray-700 space-y-2 leading-relaxed text-left">
          {step.lines.map((l, i) => (
            <p key={i}>{t(l)}</p>
          ))}
        </div>

        <div className="mt-6 flex items-center justify-center relative">
          <div className="relative bg-pink-50 rounded-xl p-4 shadow-sm w-[320px]">
            <img src={step.img} alt="help" className="w-[288px] h-auto mx-auto rounded" />
          </div>
        </div>

        <div className="mt-8 flex items-center justify-center gap-6">
          <button
            onClick={prev}
            aria-label="Previous"
            className="w-10 h-10 rounded-full bg-white border border-pink-100 shadow-sm flex items-center justify-center hover:bg-pink-50"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-pink-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          <div className="flex items-center gap-3">
            {instructions.map((_, i) => (
              <div
                key={i}
                className={`w-3 h-3 rounded-full ${i === index ? "bg-pink-600" : "bg-pink-100"}`}
              />
            ))}
          </div>

          <button
            onClick={next}
            aria-label="Next"
            className="w-10 h-10 rounded-full bg-pink-600 text-white shadow-sm flex items-center justify-center hover:bg-pink-700"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}
